// extracted by mini-css-extract-plugin
export default {"section":"styles_section__+nwlL","warning":"styles_warning__47k8x","quick-links":"styles_quick-links__qYbnk"};